export const siteSettings = {
  name: "Sphere Pips",
  link: "https://sphere-pips.com/",
  email: "support@sphere-pips.com/",
  appLink: "https://app.sphere-pips.com/",
};
